import { useState } from 'react'
import ExpandTableTextModal from './Components/ExpandTableTextModal'

/**
 * DK : Komponent do skracania tekstu w tabeli z opcją rozwinięcia w miejscu lub w modalu
 * @param {string} text - tekst do wyświetlenia
 * @param {int} maxLength - maksymalna długość tekstu przed skróceniem
 * @param {boolean} withModal - czy opcja rozwinięcia ma być w modalu
 * @returns 
 */
const ExpandTableText = ({ text, maxLength = 100, withModal = true }) => {
    const [expanded, setExpanded] = useState(false)
    const [showModal, setShowModal] = useState(false)

    if (!text || text.length <= maxLength) {
        return <span>{text}</span>
    }
    if (withModal) {
        return (<>
            <ExpandTableTextModal
                show={showModal}
                onHide={() => setShowModal(false)}
                text={text}
            />
            <span>
                {`${text.substring(0, maxLength)}...`}
                <span
                    className="ms-1 primary-accent-color-text element-pointer"
                    onClick={() => setShowModal(true)}
                >
                    więcej
                </span>
            </span>
        </>)
    }
    else {
        return (<span>
            {expanded ? text : `${text.substring(0, maxLength)}...`}
            <span
                className="ms-1 primary-accent-color-text element-pointer"
                onClick={() => setExpanded(prev => !prev)}
            >
                {expanded ? 'zwiń' : 'więcej'}
            </span>
        </span>)
    }
}

export default ExpandTableText